import { InferType, number, object, string } from "yup";

export const ApiCredentialSchema = object({
    id: number().required(),
    service: string().required("error.apiCredential.service.required"),
    login: string().optional(),
    password: string().optional(),
    apiKey: string().optional(),
    apiSecret: string().optional(),
});

export type ApiCredential = InferType<typeof ApiCredentialSchema>;

export const ApiCredentialDTOSchema = ApiCredentialSchema.omit(["id"]);

export type ApiCredentialDTO = InferType<typeof ApiCredentialDTOSchema>;

export interface IApiStatus {
    COPYSCAPE: IDefaultStatusApi;
    INDEXME: IDefaultStatusApi;
    PIXABAY: IDefaultStatusApi;
    YOURTEXTGURUStatusApi: IDefaultStatusApi;
    JARVIS: IDefaultStatusApi;
    IMAJESTICStatusApi: IDefaultStatusApi;
    UPDOWN: IDefaultStatusApi;
    OMEGAINDEXER: IDefaultStatusApi;
    SCRIBENS: IDefaultStatusApi;
    AWS_S3: IDefaultStatusApi;
    DISCORD: IDefaultStatusApi;
    DISCORD2: IDefaultStatusApi;
    DISCORD3: IDefaultStatusApi;
    DISCORD4: IDefaultStatusApi;
    IMAP: IDefaultStatusApi;
    SEORANK: IDefaultStatusApi;
    DOMDETAILER: IDefaultStatusApi;
    SEMRUSH: IDefaultStatusApi;
    DATAFORSEO: IDefaultStatusApi;
    CLOUDFLARE: IDefaultStatusApi;
}

export interface IDefaultStatusApi {
    ok: boolean;
    error?: any;
    balance: string | number;
}

export interface IMajesticStatusApi {
    ok: boolean;
    error?: any;
    balance: {
        TotalAnalysisResUnits: number;
        TotalDetailedReportsPerPeriodRemaining: number;
        TotalIndexItemInfoResUnits: number;
        TotalRetrievalResUnits: number;
    };
}
export interface IDefaultStatusApiWithLimit {
    ok: boolean;
    error?: any;
    balance: {
        remaining: number;
        limit: number;
    };
}

export interface IYourtextguruStatusApi {
    ok: boolean;
    error?: any;
    balance: {
        available_seotxl_words: number;
        available_tokens: string;
        guides_in_progress: number;
        already_generated_guides: number;
    };
}
